// turn every Effect into a Query option object
import { queryOptions } from '@tanstack/react-query'
import { serverGetPrice, serverGetStats } from '~/query/options/main'

const staleTime = 5 * 60 * 1000 // 5 minutes
const gcTime = 30 * 5 * 1000 // 30 minutes

export const statsQuery = () => queryOptions({
    queryKey: ['stats'],
    queryFn: () => serverGetStats(),
    retryOnMount: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    staleTime,
    gcTime,
    enabled: typeof window === 'undefined',
})

export const priceQuery = () => queryOptions({
    queryKey: ['price'],
    queryFn: () => serverGetPrice(),
    retryOnMount: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    staleTime,
    gcTime,
    enabled: typeof window === 'undefined',
})